import React, { Component } from "react";
import BprmForm from "../../comman/BprmForm";
import SubForm from "../PortalForms/SubForm";
import { Modal, Button } from "react-bootstrap";
import http from "../../services/HttpService";
import auth from "../../services/authService";
import config from "../../config.json";

class PatientEvalForm extends BprmForm {
  constructor(props) {
    super(props);
    this.state = {
      htmlJsonString: [
        {
          label: "?  Column",
          dataType: "column",
          id: "column",
          width: "12",
          components: [
            {
              label: "?  Label",
              dataType: "label",
              id: "label",
              attributeType: "VeteranEligibilityForm",
              validation: {},
              formIcons: "fa fa-check-circle thankYouCheckCss",
              styleCss: { textalign: "center" },
            },
          ],
        },
        {
          label: "?  Column",
          dataType: "column",
          id: "column",
          width: "12",
          components: [
            {
              label: "?  Label",
              dataType: "label",
              id: "label",
              text: "THANK YOU!",
              attributeType: "VeteranEligibilityForm",
              validation: {},
              styleCss: { textalign: "center" },
              attributeDataTypes: { type: "h1" },
            },
          ],
        },
        {
          label: "?  Column",
          dataType: "column",
          id: "column",
          width: "12",
          components: [
            {
              label: "?  Label",
              dataType: "label",
              id: "label",
              text:
                "We have received your application and it is being processed. ",
              attributeType: "VeteranEligibilityForm",
              validation: {},
              styleCss: { textalign: "center" },
              attributeDataTypes: { type: "h4" },
            },
            {
              label: "?  Label",
              dataType: "label",
              id: "label",
              text: "We will revert to you as soon as possible.",
              attributeType: "VeteranEligibilityForm",
              validation: {},
              styleCss: { textalign: "center" },
            },
          ],
        },
        {
          label: "?  Column",
          dataType: "column",
          id: "column",
          width: "12",
          components: [
            {
              label: "?  Label",
              dataType: "label",
              id: "label",
              text:
                "Your application will be reviewed by the assigned Review Officer immediately.&lt;br&gt;Please sign-in with the user credentials provided to you and while in the portal click on Check Your Application Processing Status to see the updates on your application.&lt;br&gt;You may also communicate with the assigned Review Officer by using the messaging feature, and also upload or receive documents as may be required for the processing of your application.",
              attributeType: "VeteranEligibilityForm",
              validation: {},
              cssclass: "backgroundColor",
              styleCss: { textalign: "center" },
            },
          ],
        },
        {
          label: "?  Column",
          dataType: "column",
          id: "column",
          width: 6,
          components: [
            {
              label: "Close",
              id: "close",
              dataType: "button",
              navigationPage: "",
              buttonType: { type: "exit", name: "Exit" },
              style: "btn btn-outline-default",
              formIcons: "fa fa-times-circle",
            },
            {
              label: "Home Page",
              id: "homePage",
              dataType: "button",
              navigationPage: "",
              buttonType: { type: "home", name: "Home Page" },
              formProcess: 3,
              style: "btn btn-outline-default",
              formIcons: "fa fa-save",
            },
            {
              label: "Check Your Application Status",
              id: "checkYourApplicationStatus",
              dataType: "button",
              navigationPage: "",
              buttonType: {
                type: "checkStatus",
                name: "Application Status Page",
              },
              style: "btn btn-outline-default",
              formIcons: "fa fa-check-circle thankYouCheckCss",
            },
          ],
        },
      ],
      application: {},
      aWorkfinityAppEntity: {},
      wfForm: {},
      data: {},
      errors: {},
      encryptionDecryptions: {},
      aWorkfinityApp: {},
      rules: [
        {
          ruleId: 4,
          ruleEntity: "textBox.Result1",
          rule:
            "(ParentConsentInfo.Provider_name + ParentConsentInfo1.Provider_name)Test101.root, + (ParentConsentInfo.Provider_name + ParentConsentInfo1.Provider_name)2,",
        },
      ],
      workItem: {},
      showHide: false,
      processId: 0,
      formProcess: [],
      isDisabled: false,
      stateList: [],
      stateCountyCity: [],
      user: {},
    };
  }

  async componentDidMount() {
    const { data: wfForm } = await http.get(config.GetForm + 112);
    this.setState({ wfForm });
    const user = auth.getCurrentUser();
    this.setState({ user });
  }

  render() {
    const {
      surveyShowHide,
      handleSurveyShowHide,
      //wfForm,
      // aWorkfinityAppEntity,
      patientInfo
    } = this.props;
    const { wfForm, aWorkfinityAppEntity,user } = this.state;
    const elements = //htmlJsonString;
      wfForm !== undefined &&
      wfForm.elementJson != undefined &&
      JSON.parse(wfForm.elementJson);

    return (
      <Modal show={surveyShowHide} size="xl">
        <Modal.Header closeButton onClick={handleSurveyShowHide}>
          <Modal.Title>Self Evaluation Reports</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-secondary p-3">
          <div className="row">
            <div
              className="col-lg-12"
              style={{ maxHeight: "450px", overflow: "auto" }}
            >
              <ul className="list-group">
                <li className="list-group-item">
                  <div className="row">
                    <div className="col-md-3 form-group">
                      <label htmlFor="" className="form-control-label">
                        Patient Id : {patientInfo.regId}
                      </label>
                    </div>
                    <div className="col-md-9 form-group">
                      <label htmlFor="" className="form-control-label">
                        Patient Name : {patientInfo.applicantName}
                      </label>
                    </div>
                    <div className="col-md-3 form-group">
                      <label htmlFor="" className="form-control-label">
                        {" "}
                        Patient Status :
                      </label>

                      <button className="btn btn-outline-default btn-sm ml-2">
                        Approved
                      </button>
                    </div>
                    <div className="col-md-9 form-group">
                      <label htmlFor="" className="form-control-label">
                        {" "}
                        Last Report Status :
                      </label>
                      <button className="btn btn-outline-default btn-sm ml-2">
                        Closed
                      </button>
                    </div>
                  </div>
                </li>
              </ul>
              <ul className="list-group">
                {/* <li className="list-group-item">
                  Form 1 : {wfForm.name}
                </li> */}
                <li className="list-group-item">
                  <div className="row">
                    {elements &&
                      elements
                        .filter((x) => x.groupName !== "otherCriteria")
                        .map((col) => (
                          <div className={`col-` + col.width}>
                            {col.components.map((comp) => {
                              if (comp.dataType === "list") {
                                return (
                                  <SubForm
                                    showHide={
                                      this.state["showHide" + comp.subform]
                                    }
                                    handleModalShowHide={
                                      this.handleModalShowHide
                                    }
                                    title={comp.label}
                                    subFormId={comp.subform}
                                    aWorkfinityAppEntity={aWorkfinityAppEntity}
                                  ></SubForm>
                                );
                              } else if (comp.dataType === "button") {
                              } else {
                                return this.rendorHtmlComponent(comp);
                              }
                            })}
                          </div>
                        ))}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="danger" onClick={handleSurveyShowHide}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>
    );
  }
}

export default PatientEvalForm;
